import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';

import Home                from './pages/Home';
import Login               from './pages/Login';
import Register            from './pages/Register';
import Dashboard           from './pages/Dashboard';
import FilingForm          from './pages/FilingForm';
import GstRegistration     from './pages/GstRegistration';
import GstReturnForm       from './pages/GstReturnForm';
import DscForm             from './pages/DscForm';

import { ItrApplicationDetail, GstApplicationDetail, GstReturnDetail, DscApplicationDetail }
                           from './pages/Applications';

import { AdminDashboard, AdminFilings, AdminFilingDetail }
                           from './pages/Admin';
import { AdminGstList, AdminGstDetail }
                           from './pages/AdminGst';
import { AdminGstReturnList, AdminGstReturnDetail }
                           from './pages/AdminGstReturns';
import { AdminDscList, AdminDscDetail }
                           from './pages/AdminDsc';
import AdminEnquiries      from './pages/AdminEnquiries';
import AdminPayments       from './pages/AdminPayments';
import NewsArticlesFiles   from './pages/NewsArticlesFiles';
import AdminSettings       from './pages/AdminSettings';
import AdminBridgeController from './pages/AdminBridgeController';


function AuthRedirect() {
  const { isLoggedIn, isAdmin } = useAuth();
  if (isLoggedIn) return <Navigate to={isAdmin ? '/admin' : '/dashboard'} replace />;
  return null;
}

function MainApp() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <Routes>

        {/* ── Public ───────────────────────────────────────────── */}
        <Route path="/"         element={<Home />} />
        <Route path="/updates"  element={<NewsArticlesFiles />} />
        <Route path="/login"    element={<><AuthRedirect /><Login /></>} />
        <Route path="/register" element={<><AuthRedirect /><Register /></>} />

        {/* ── User ─────────────────────────────────────────────── */}
        <Route path="/dashboard"
          element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/file"
          element={<ProtectedRoute><FilingForm /></ProtectedRoute>} />
        <Route path="/gst"
          element={<ProtectedRoute><GstRegistration /></ProtectedRoute>} />
        <Route path="/gst-return"
          element={<ProtectedRoute><GstReturnForm /></ProtectedRoute>} />
        <Route path="/dsc"
          element={<ProtectedRoute><DscForm /></ProtectedRoute>} />

        {/* User application detail pages */}
        <Route path="/applications/itr/:id"
          element={<ProtectedRoute><ItrApplicationDetail /></ProtectedRoute>} />
        <Route path="/applications/gst/:id"
          element={<ProtectedRoute><GstApplicationDetail /></ProtectedRoute>} />
        <Route path="/applications/gst-return/:id"
          element={<ProtectedRoute><GstReturnDetail /></ProtectedRoute>} />
        <Route path="/applications/dsc/:id"
          element={<ProtectedRoute><DscApplicationDetail /></ProtectedRoute>} />

        {/* ── Admin ────────────────────────────────────────────── */}
        <Route path="/admin"
          element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/filings"
          element={<ProtectedRoute adminOnly><AdminFilings /></ProtectedRoute>} />
        <Route path="/admin/filings/:id"
          element={<ProtectedRoute adminOnly><AdminFilingDetail /></ProtectedRoute>} />
        <Route path="/admin/gst"
          element={<ProtectedRoute adminOnly><AdminGstList /></ProtectedRoute>} />
        <Route path="/admin/gst/:id"
          element={<ProtectedRoute adminOnly><AdminGstDetail /></ProtectedRoute>} />
        <Route path="/admin/gst-returns"
          element={<ProtectedRoute adminOnly><AdminGstReturnList /></ProtectedRoute>} />
        <Route path="/admin/gst-returns/:id"
          element={<ProtectedRoute adminOnly><AdminGstReturnDetail /></ProtectedRoute>} />
        <Route path="/admin/dsc"
          element={<ProtectedRoute adminOnly><AdminDscList /></ProtectedRoute>} />
        <Route path="/admin/dsc/:id"
          element={<ProtectedRoute adminOnly><AdminDscDetail /></ProtectedRoute>} />
        <Route path="/admin/enquiries"
          element={<ProtectedRoute adminOnly><AdminEnquiries /></ProtectedRoute>} />
        <Route path="/admin/payments"
          element={<ProtectedRoute adminOnly><AdminPayments /></ProtectedRoute>} />
        <Route path="/admin/settings"
          element={<ProtectedRoute adminOnly><AdminSettings /></ProtectedRoute>} />
        <Route path="/admin/bridge"
          element={<ProtectedRoute adminOnly><AdminBridgeController /></ProtectedRoute>} />

        {/* ── Fallback ─────────────────────────────────────────── */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <MainApp />
    </BrowserRouter>
  );
}